'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../util');

var _lodash = require('lodash.range');

var _lodash2 = _interopRequireDefault(_lodash);

var _Base = require('../Base');

var _Base2 = _interopRequireDefault(_Base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var defaultSize = 22;

var Wave = function Wave(_ref, _ref2) {
  var color = _ref.color;
  var columns = _ref.columns;
  var columnWidth = _ref.columnWidth;
  var gutterWidth = _ref.gutterWidth;
  var scaleYEnd = _ref.scaleYEnd;
  var scaleYStart = _ref.scaleYStart;
  var size = _ref.size;

  var props = _objectWithoutProperties(_ref, ['color', 'columns', 'columnWidth', 'gutterWidth', 'scaleYEnd', 'scaleYStart', 'size']);

  var _ref2$betterReactSpin = _ref2.betterReactSpinkit;
  var betterReactSpinkit = _ref2$betterReactSpin === undefined ? {} : _ref2$betterReactSpin;

  var name = (0, _util.animationName)('wave');
  var finalSize = (0, _util.preside)(size, betterReactSpinkit.size, defaultSize);
  var outer = {
    display: 'flex',
    justifyContent: 'space-between',
    height: finalSize - finalSize * 0.2,
    width: finalSize
  };
  var column = _extends({}, (0, _util.animate)({ name: name }), {
    backgroundColor: color || betterReactSpinkit.color || _util.defaults.color,
    height: '100%',
    width: columnWidth
  });
  return _react2.default.createElement(
    _Base2.default,
    _extends({
      css: '\n        @-webkit-keyframes ' + name + ' {\n          0%, 40%, 100% {\n            -webkit-transform: scaleY(' + scaleYStart + ')\n          }\n          20% {\n            -webkit-transform: scaleY(' + scaleYEnd + ')\n          }\n        }\n        @keyframes ' + name + ' {\n          0%, 40%, 100% {\n            transform: scaleY(' + scaleYStart + ');\n            -webkit-transform: scaleY(' + scaleYStart + ');\n          }\n          20% {\n            transform: scaleY(' + scaleYEnd + ');\n            -webkit-transform: scaleY(' + scaleYEnd + ');\n          }\n        }\n      '
    }, props),
    _react2.default.createElement(
      'div',
      { style: outer },
      (0, _lodash2.default)(columns).map(function (index) {
        return _react2.default.createElement('div', {
          key: index,
          style: _extends({}, column, (0, _util.animate)({ delay: '-' + index / 10 + 's' }), {
            marginRight: index !== columns ? gutterWidth : 0
          })
        });
      })
    )
  );
};

Wave.propTypes = {
  /**
   * The color of the spinner.
   */
  color: _react.PropTypes.string,
  /**
   * The amount of columns.
   */
  columns: _react.PropTypes.number,
  /**
   * The width of each column.
   */
  columnWidth: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  /**
   * The pixel value between columns.
   */
  gutterWidth: _react.PropTypes.number,
  /**
   * Ending column height.
   */
  scaleYEnd: _react.PropTypes.number,
  /**
   * Starting column height.
   */
  scaleYStart: _react.PropTypes.number,
  /**
   * The size of the spinner.
   */
  size: _react.PropTypes.number
};

Wave.defaultProps = {
  columns: 5,
  columnWidth: '20%',
  gutterWidth: 1,
  scaleYEnd: 1,
  scaleYStart: 0.4,
  size: defaultSize
};

Wave.contextTypes = _util.defaults.contextTypes;

exports.default = Wave;


//////////////////
// WEBPACK FOOTER
// ./~/better-react-spinkit/dist/Wave/index.js
// module id = 412
// module chunks = 0